import { render } from "./COptions.vue?vue&type=template&id=31912e0c&ts=true"
import script from "./COptions.vue?vue&type=script&lang=ts"
export * from "./COptions.vue?vue&type=script&lang=ts"

import "./COptions.vue?vue&type=style&index=0&id=31912e0c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__